import { useCookies } from 'react-cookie';

export const isSkipCaptcha = (cookieName?: string) => {
    if (!cookieName) {
        return false;
    }

    const [cookies] = useCookies([cookieName]);
    return !!cookies[cookieName];
};
